var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / plus"),React.createElement("g",{"id":"icons-/-plus","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M13,0 L13,11 L24,11 L24,13 L13,13 L13,24 L11,24 L11,13 L0,13 L0,11 L11,11 L11,0 L13,0 Z","id":"plus","fill":"#1E1E1E"}))]);
}

Plus.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Plus;

Plus.default = Plus;
